export class WyreStormSw740Tx {
    constructor(socket) {
        this.socket = socket;
        this.power = false;
        this.videoMatrixRoutes = 'in1';
        this.volume = 50;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'autoSwitch',
                regExp: /SET AUTOSW_FN (on|off)/i,
                callback: (match) => {
                    this.socket.send(`AUTOSW_FN ${match[1]}`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /GET STANDBY/i,
                callback: (match) => {
                    this.socket.send(`STANDBY ${this.power ? 'off' : 'on'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /SET STANDBY (.+)/i,
                callback: (match) => {
                    this.power = match[1] === 'off';
                    this.socket.send(`STANDBY ${this.power ? 'off' : 'on'}`);
                },
            },
            {
                name: 'videoMatrixRoutesQuery',
                regExp: /GET MP all/i,
                callback: (match) => {
                    this.socket.send(`MP ${this.videoMatrixRoutes} all`);
                },
            },
            {
                name: 'videoMatrixRoutesSet',
                regExp: /SET SW (.+) all/i,
                callback: (match) => {
                    this.videoMatrixRoutes = match[1];
                    this.socket.send(`SW ${this.videoMatrixRoutes} all`);
                },
            },
            {
                name: 'volumeQuery',
                regExp: /GET VOLUME/i,
                callback: (match) => {
                    this.socket.send(`VOLUME ${this.volume}`);
                },
            },
            {
                name: 'volumeSet',
                regExp: /SET VOLUME (.+)/i,
                callback: (match) => {
                    this.volume = parseInt(match[1], 10);
                    this.socket.send(`VOLUME ${this.volume}`);
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /GET AUDOUT_MUTE/i,
                callback: (match) => {
                    this.socket.send(`AUDOUT_MUTE ${this.volumeMute ? 'on' : 'off'}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /SET AUDOUT_MUTE (.+)/i,
                callback: (match) => {
                    this.volumeMute = match[1] === 'on';
                    this.socket.send(`AUDOUT_MUTE ${this.volumeMute ? 'on' : 'off'}`);
                },
            },
        ];
    }
}
WyreStormSw740Tx.emulatorType = 'socketEmulator';
WyreStormSw740Tx.key = '-Ms1RVBlDI_U_G8lbbzj';
